module.exports = __webpack_public_path__ + "fonts/Arzypto-Dashboard.91ce493.woff";